import React from 'react';
import './ContentLayout.less';
import HwzComponent from '../../common/component/HwzComponent';

interface IProps {}

interface IState {}

export default class ContentLayout extends HwzComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    let that = this;

    return (
      <div id="layout-content" className="layout-content">
        {this.props.children}
      </div>
    );
  }
}
